import script from "./joinUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./joinUs.vue?vue&type=script&lang=ts&setup=true"

import "./joinUs.vue?vue&type=style&index=0&id=56c71152&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c71152"]])

export default __exports__